<template>
  <div>
    <Piso/>
  </div>
</template>
<script>
import Piso from '../torrespanorama/mapLocation/Piso'
export default {
  name: "PisoMenu",
  components: {
    Piso
  }
}
</script>
<style scoped>
</style>